import { render, staticRenderFns } from "./plays.vue?vue&type=template&id=4214ae56&scoped=true&"
import script from "./plays.vue?vue&type=script&lang=ts&"
export * from "./plays.vue?vue&type=script&lang=ts&"
import style0 from "./plays.vue?vue&type=style&index=0&id=4214ae56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4214ae56",
  null
  
)

export default component.exports